// Filename - App.js

import "./App.css";
import Sidebar from "./components/Sidebar";
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";

import Welcome from "./pages/Welcome";

import {
    About,
} from "./pages/About";
import {
    Services,
    DirectoryService,
    AppHosting,
    InternalReporting,
} from "./pages/Services";
import Contact from "./pages/ContactUs";
import Support from "./pages/Support";
function App() {
    return (
        <Router>
            <Sidebar />
            <Routes>
                <Route
                    path="/"
                    element={<Welcome />}
                />
                <Route
                    path="/welcome"
                    element={<Welcome />}
                />
                <Route
                    path="/about"
                    element={<About />}
                />
                <Route
                    path="/services"
                    element={<Services />}
                />
                <Route
                    path="/services/DirectoryService"
                    element={<DirectoryService />}
                />
                <Route
                    path="/services/AppHosting"
                    element={<AppHosting />}
                />
                <Route
                    path="/services/InternalReporting"
                    element={<InternalReporting />}
                />
                <Route
                    path="/contact"
                    element={<Contact />}
                />
                <Route
                    path="/support"
                    element={<Support />}
                />
            </Routes>
        </Router>
    );
}

export default App;